import React from "react";

function ErrorModal({ show, errors, onClose }) {
  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ backgroundColor: show ? "rgba(0,0,0,0.5)" : "transparent" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title">Error{errors.length > 1 ? "s" : ""}</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {errors.length > 0 ? (
              <ul className="list-group list-group-flush">
                {errors.map((err, index) => (
                  <li key={index} className="list-group-item text-danger">
                    {err}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No errors</p>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorModal;
